// Boss Talk - Daily motivational quotes from hip-hop entrepreneurs and philosophers
// Used in the GuapGoals app for daily motivation

export const BOSS_QUOTES = [
  // Hip-Hop Entrepreneurs
  { quote: "I'm not a businessman, I'm a business, man.", author: "Jay-Z", category: "hustle" },
  { quote: "The goal is to be rich forever.", author: "Nipsey Hussle", category: "wealth" },
  { quote: "Sleep is for those who are broke.", author: "50 Cent", category: "grind" },
  { quote: "I'd rather invest in real estate than in diamonds.", author: "Jay-Z", category: "investing" },
  { quote: "Having money isn't everything, not having it is.", author: "Kanye West", category: "reality" },
  { quote: "The marathon continues.", author: "Nipsey Hussle", category: "persistence" },
  { quote: "I'm a movement by myself, but I'm a force when we're together.", author: "Nipsey Hussle", category: "community" },
  { quote: "Scared money don't make no money.", author: "Young Jeezy", category: "risk" },
  { quote: "I'm not greedy, I'm ambitious. There's a difference.", author: "50 Cent", category: "ambition" },
  { quote: "The first step to getting what you want is having the courage to get rid of what you don't.", author: "Rick Ross", category: "focus" },
  { quote: "Don't ever go with the flow. Be the flow.", author: "Jay-Z", category: "leadership" },
  { quote: "Excellence is not a skill, it's an attitude.", author: "Nipsey Hussle", category: "mindset" },
  { quote: "In the land of the blind, the man with one eye is king.", author: "Jay-Z", category: "vision" },
  { quote: "I got my mind on my money and my money on my mind.", author: "Snoop Dogg", category: "focus" },
  { quote: "Started from the bottom now we're here.", author: "Drake", category: "journey" },
  { quote: "Ain't no such thing as halfway crooks.", author: "Mobb Deep", category: "commitment" },
  { quote: "Get rich or die tryin'.", author: "50 Cent", category: "determination" },
  { quote: "Mo' money, mo' problems, but still I rather have it.", author: "J. Cole", category: "reality" },
  
  // Philosophers & Thinkers
  { quote: "Wealth consists not in having great possessions, but in having few wants.", author: "Epictetus", category: "philosophy" },
  { quote: "It is not the man who has too little that is poor, but the one who hangers after more.", author: "Seneca", category: "contentment" },
  { quote: "He who is not contented with what he has, would not be contented with what he would like to have.", author: "Socrates", category: "contentment" },
  { quote: "Beware of little expenses; a small leak will sink a great ship.", author: "Benjamin Franklin", category: "saving" },
  { quote: "The only way to do great work is to love what you do.", author: "Steve Jobs", category: "passion" },
  { quote: "Compound interest is the eighth wonder of the world.", author: "Albert Einstein", category: "investing" },
  { quote: "Price is what you pay, value is what you get.", author: "Warren Buffett", category: "value" },
  { quote: "Don't save what is left after spending; spend what is left after saving.", author: "Warren Buffett", category: "saving" },
  { quote: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin", category: "education" },
  { quote: "Never depend on single income. Make investments to create a second source.", author: "Warren Buffett", category: "diversification" },
  { quote: "The rich invest in time, the poor invest in money.", author: "Warren Buffett", category: "time" },
  { quote: "Formal education will make you a living; self-education will make you a fortune.", author: "Jim Rohn", category: "growth" },
  { quote: "Know what you own, and know why you own it.", author: "Peter Lynch", category: "investing" },
  { quote: "The habit of saving is itself an education.", author: "T.T. Munger", category: "saving" },
  { quote: "A wise person should have money in their head, but not in their heart.", author: "Jonathan Swift", category: "balance" },
  { quote: "Money is only a tool. It will take you wherever you wish, but it will not replace you as the driver.", author: "Ayn Rand", category: "control" },
  { quote: "The art is not in making money, but in keeping it.", author: "Proverb", category: "preservation" },
  
  // Modern Entrepreneurs
  { quote: "Your time is limited, don't waste it living someone else's life.", author: "Steve Jobs", category: "purpose" },
  { quote: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb", category: "action" },
  { quote: "Risk comes from not knowing what you're doing.", author: "Warren Buffett", category: "knowledge" },
  { quote: "The question isn't who is going to let me; it's who is going to stop me.", author: "Ayn Rand", category: "determination" },
  { quote: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill", category: "resilience" },
  { quote: "Do not be embarrassed by your failures, learn from them and start again.", author: "Richard Branson", category: "resilience" },
  { quote: "The biggest risk is not taking any risk.", author: "Mark Zuckerberg", category: "risk" },
];

// Get a quote based on the day (rotates daily)
export const getDailyQuote = () => {
  const today = new Date();
  const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24));
  return BOSS_QUOTES[dayOfYear % BOSS_QUOTES.length];
};

// Get a random quote
export const getRandomQuote = () => {
  return BOSS_QUOTES[Math.floor(Math.random() * BOSS_QUOTES.length)];
};

// Get quotes by category
export const getQuotesByCategory = (category) => {
  return BOSS_QUOTES.filter(q => q.category === category);
};

export default BOSS_QUOTES;
